export const KOLIBRI_METER_ID = '';
